<template>
  <div style="display: flex; justify-content: center">
    <div class="wizard-header">
      <div class="wizard-node" :class="nodeClass(1)" @click="irPara(1)">
        <div class="wizard-circle">
          <v-icon v-if="isComplete(1)" color="#4075FF" size="16">mdi-check</v-icon>
          <span v-else>1</span>
        </div>
        <div class="wizard-label">Escopo (itens)</div>
      </div>

      <div class="wizard-line"></div>

      <SysTooltip2 text="Selecione ao menos 1 item para continuar." top>
        <template #activator>
          <div class="wizard-node" :class="nodeClass(2)" @click="podeIr(2) && irPara(2)">
            <div class="wizard-circle">
              <v-icon v-if="isComplete(2)" color="#4075FF" size="16">mdi-check</v-icon>
              <span v-else>2</span>
            </div>
            <div class="wizard-label">Rodadas de compras</div>
          </div>
        </template>
      </SysTooltip2>

      <div class="wizard-line"></div>

      <SysTooltip2 text="Crie e salve ao menos 1 rodada de compra válida." top>
        <template #activator>
          <div class="wizard-node" :class="nodeClass(3)" @click="podeIr(3) && irPara(3)">
            <div class="wizard-circle">
              <v-icon v-if="isComplete(3)" color="#4075FF" size="16">mdi-check</v-icon>
              <span v-else>3</span>
            </div>
            <div class="wizard-label">Influência</div>
          </div>
        </template>
      </SysTooltip2>

      <div class="wizard-line"></div>

      <SysTooltip2 text="Revise rodadas e influência antes de aplicar." right>
        <template #activator>
          <div class="wizard-node" :class="nodeClass(4)" @click="podeIr(4) && irPara(4)">
            <div class="wizard-circle">
              <v-icon v-if="isComplete(4)" color="#4075FF" size="16">mdi-check</v-icon>
              <span v-else>4</span>
            </div>
            <div class="wizard-label">Revisão e aplicar</div>
          </div>
        </template>
      </SysTooltip2>
    </div>
  </div>
</template>

<script>
import SysTooltip2 from "@/components/utils/ui_v4/tooltips/SysTooltip2.vue";

export default {
  name: 'WizardSteps',
  components: { SysTooltip2 },
  props: {
    step: { type: Number, required: true },
    irPara: { type: Function, required: true },
    podeIr: {
      type: Function,
      default: () => () => true
    },
    errosPorStep: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    isComplete(n) {
      const hasError = !!(this.errosPorStep && this.errosPorStep[n] === true);
      return this.step > n && !hasError;
    },
    nodeClass(n) {
      const hasError = !!(this.errosPorStep && this.errosPorStep[n] === true);
      return {
        'is-active': this.step === n && !hasError,
        'is-complete': this.step > n,
        'is-error': hasError
      }
    }
  }
}
</script>

<style scoped>
.wizard-header {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}

.wizard-node {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  min-width: 120px;
}

.wizard-label {
  font-weight: 400;
  margin-bottom: 3px;
  color: #73787F;
  text-align: center;
  font-size: 14px;
  cursor: pointer;
}

.wizard-circle {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #F4F4F6;
  color: #73787F;
  border: 1px solid #ABAEB5;
  font-size: 12px;
  font-weight: 400;
  transition: all .2s ease;
  margin-right: 10px;
}

.wizard-line {
  flex: 1;
  height: 5px;
  background: #E2E2E4;
  margin: 0 4px 0 4px;
  border-radius: 20px;
  min-width: 80px;
}

.wizard-node.is-active .wizard-circle {
  cursor: pointer;
  border-color: #245AE5;
  background: #6691FF;
  color: #fff;
}

.wizard-node.is-error .wizard-circle {
  background: #C0142F;
  color: #fff;
  border-color: transparent;
}

.wizard-node.is-error .wizard-label {
  color: #C0142F;
}

.wizard-node.is-complete .wizard-circle {
  background: #D9E3FF;
  border: 1px solid #4075FF;
  color: #fff;
}

.wizard-node.is-complete .wizard-label {
}

@media (max-width: 700px) {
  .wizard-label {
    font-size: 13px
  }

  .wizard-circle {
    width: 52px;
    height: 52px;
    font-size: 18px
  }
}
</style>
